export default {
    error: require('./oops.svg')
}